import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/CodeBookItems/CodeBookItems.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CodeBookItemsForm } from '../../../forms/CodeBookItems/CodeBookItemsForm';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { paths } from '../../RouterContainer';
import { useTranslation } from '../../../context/translationContext';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useEffect } from 'react';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component represents code book items overview
 */
export const CodeBookItemsCreatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { company } = useCurrentCompany();
  const { startLoading, stopLoading } = useLoading();
  const { setBreadcrumbs } = useBreadcrumbs();
  useEffect(() => {
    setBreadcrumbs([
      { path: paths.CODE_BOOK_ITEMS, name: 'navigation.code-book-items' },
      { path: `${paths.CODE_BOOK_ITEMS}/create`, name: 'navigation.code-book-item-create' },
    ]);
  }, []);

  /**
   * Handles create action for new code book item form submit.
   * Uses company create API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    if (!company) return;
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.CODE_BOOK_ITEM_CREATE,
        data: { ...values, companyId: company.id },
      });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        navigate(`/${paths.CODE_BOOK_ITEMS}/edit/${response.data?.id}`);
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.code-book-item.headline-create')}</h1>
      <CodeBookItemsForm onSubmit={handleSubmit} />
    </div>
  );
};
